import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

declare let jQuery: any;
import {
    Component,
    OnInit,
    Input,
    AfterViewInit,
    ElementRef,
    EventEmitter,
    Output,
    SimpleChanges,
    SimpleChange
} from '@angular/core';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.css']
})
export class DateTimePickerComponent implements OnInit, AfterViewInit {

    @Input() options: DateTimePickerOptions;
    @Input() inputSmall = false;
    @Input() invalid: boolean = false;
    @Input() valid: boolean = false;
    @Input() date: Moment;
    @Output() dateChange = new EventEmitter<Moment>();

    private $dateTimePicker: any;

    private _options: DateTimePickerOptions;

    constructor(private _element: ElementRef) {
    }

    ngOnInit() {
        this._options = new DateTimePickerOptions(this.options);
        if (this.date && this.date.isValid()) {
            this._options.defaultDate = this.date;
        }
    }

    ngAfterViewInit() {
        let _this = this;
        this.$dateTimePicker = jQuery(this._element.nativeElement);
        this.$dateTimePicker
            .find('.date-time-picker')
            .datetimepicker(this._options)
            .on('dp.change', function (e) {
                _this.date = moment(e.date);
                _this.dateChange.emit(_this.date);
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        const date: SimpleChange = changes.date;
        if (date && date.currentValue) {
            if (this.$dateTimePicker && this.$dateTimePicker.find('.date-time-picker') && this.$dateTimePicker.find('.date-time-picker').data('DateTimePicker')) {
                this.$dateTimePicker.find('.date-time-picker').data('DateTimePicker').date(this.date);
            }
        }
    }
}

export interface IDateTimePickerOptions {
    locale?: string;
    defaultDate: Moment;
    minDate?: Moment | boolean;
    format?: string;
    calendarWeeks?: boolean;
}

export class DateTimePickerOptions {
    showClear?: boolean = true;
    locale?: string;
    defaultDate: Moment;
    minDate?: Moment | boolean;
    format?: string;
    calendarWeeks?: boolean;
    icons: any = {
        // time: 'glyphicon glyphicon-time',
        // date: 'glyphicon glyphicon-calendar',
        up: 'fas fa-chevron-up',
        down: 'fas fa-chevron-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        // today: 'glyphicon glyphicon-screenshot',
        clear: 'fas fa-trash',
        close: 'fas fa-times'
    }

    constructor(obj?: IDateTimePickerOptions) {
        this.locale = obj && obj.locale ? obj.locale : 'da';
        this.minDate = obj && obj.minDate ? obj.minDate : false;
        this.format = obj && obj.format ? obj.format : 'YYYY-MM-DD';
        this.calendarWeeks = (obj && obj.calendarWeeks === true) ? true : false;
    }
}
